export enum BookingType {
  ONE_STAGE = "ONE_STAGE",
  TWO_STAGE = "TWO_STAGE",
}